import { render, staticRenderFns } from "./loading-branch-card.vue?vue&type=template&id=2d656da0&scoped=true&"
import script from "./loading-branch-card.vue?vue&type=script&lang=js&"
export * from "./loading-branch-card.vue?vue&type=script&lang=js&"
import style0 from "./loading-branch-card.vue?vue&type=style&index=0&id=2d656da0&lang=scss&scoped=true&"
import style1 from "./loading-branch-card.vue?vue&type=style&index=1&id=2d656da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d656da0",
  null
  
)

export default component.exports
import {QCard,QSkeleton,QCardSection,QImg,QSpinnerIos,QCardActions,QBtn,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QSkeleton,QCardSection,QImg,QSpinnerIos,QCardActions,QBtn,QIcon})
